<template lang="html">
  <section :id="id" class="overview-edit-name">
    <div class="inline-content" v-if="isDisplayContent">
      <div class="current-value">{{ currentValue }}</div>
      <div
        class="icon-container"
        @click.stop="onClickEdit"
        v-if="displayEditIcon"
      >
        <svg class="icon">
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#edit"
          />
        </svg>
      </div>
    </div>

    <div v-else class="inline-content">
      <input
        ref="inputText"
        class="text-input"
        v-model="updatedValue"
        type="text"
        autocomplete="off"
        :disabled="displayLoader"
      />
      <div class="icon-container">
        <svg class="icon" @click.stop="onClickCancel">
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#close"
          />
        </svg>
        <svg class="icon" @click.stop="onClickSave">
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#check"
          />
        </svg>
      </div>
    </div>

    <div class="loader" v-if="displayLoader"></div>
  </section>
</template>

<script lang="js">
  import { TOAST_OPTIONS } from "@/static/global-variables";
  import DistributionChannelsService from "@/services/distributionChannelsService";

  export default  {
    name: "overview-edit-name",
    props: {
      id: {
        type: String
      },
      name: {
        type: String
      },
      uuid: {
        type: String
      }
    },
    data () {
      return {
        isDisplayContent: true,
        displayLoader: false,
        updatedValue: null
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      displayEditIcon() {
        return Boolean(this.name && !this.displayLoader);
      },
      currentValue() {
        return this.updatedValue || this.name;
      }
    },
    methods: {
      onClickEdit() {
        this.isDisplayContent = false;
        this.$nextTick(() => {
          this.$refs.inputText.focus();
          this.resetUpdatedValue();
        });
      },
      onClickCancel() {
        this.isDisplayContent = true;
        this.resetUpdatedValue();
      },
      resetUpdatedValue() {
        this.updatedValue = this.name;
      },
      onClickSave() {
        const name = this.updatedValue.trim();
        this.isDisplayContent = true;
        if(this.allowUpdate(name)) {
          this.displayLoader = true;
          DistributionChannelsService.distributionChannelName(this.uuid, name)
          .catch(() => {
            this.updatedValue = null;
            this.$bvToast.toast(this.getMessageText(this.messages.SAVE_ERROR), TOAST_OPTIONS.bottomCenter);
          })
          .finally(() => {
            this.displayLoader = false;
          });
        }
      },
      allowUpdate(name) {
        return Boolean(name) && this.name !== name && !this.displayLoader;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  .overview-edit-name {
    box-sizing: border-box;
    display: flex;
    .text-input {
      @include mixin-text-input;
    }
    .inline-content {
      display: flex;
      .current-value {
        box-sizing: border-box;
        margin-left: 0.2rem;
      }
      .icon-container {
        font-size: initial;
        padding: 0.3rem;
      }
      .icon {
        width: 1.5rem;
        height: 1.5rem;
        padding: 0.3rem;
        cursor: pointer;
        fill: var(--DARK_GREY);
      }
    }
    .loader {
      margin-left: 1rem;
      margin-top: 0.3rem;
      width: 1.8rem;
      height: 1.8rem;
    }
  }
</style>
